'use strict';
import React, { Component } from 'react'
var FormatMessage = require('react-globalize').FormatMessage;

export default class PopularScams extends Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div className="container">
        <div className="row text-justify">

          {
            this.props.locale == "es" ?
            <div className="col-md-12" style={{padding:25}}>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    El acecho no solo ocurre en los sitios de citas. “Los estafadores de romances se dirigen a personas 
                    desprevenidas en grupos virtuales de oración y lectura, en juegos virtuales como Words With Friends 
                    y otros grupos a los que recurrimos debido al aislamiento impuesto por la pandemia”.
                    <br/>
                    “Los estafadores a menudo invitan a sus víctimas románticas a que se alejen de los sitios que pueden 
                    ser monitoreados y los llevan a Google Hangouts, WhatsApp, Facebook o Messenger donde nadie los ve y 
                    comienzan a pedir dinero”.
                    <br/>
                    <b>NUNCA</b> enviar dinero a alguien que no conoces. Rechace las solicitudes de selfies y videos provocativos 
                    que un estafador puede usar más tarde para extorsionarlo.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/online.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Los estafadores envían correos electrónicos y llamadas telefónicas, e incluso entran a las casas 
                    haciéndose pasar por empleados de Medicare y ofrecen todo tipo de servicios relacionados con la 
                    pandemia para obtener su número de identificación de Medicare.
                    <br/>
                    “Las ofertas incluyen nuevas tarjetas que, según los estafadores, contienen microchips”, Otros 
                    estafadores piden dinero para adelantar a los beneficiarios en la fila para recibir la vacuna 
                    contra el COVID-19”.
                    <br/>
                    <b>CUELGA</b> la llamada, cierra la puerta y borra el correo electrónico. De acuerdo con los Centros 
                    de Servicios de Medicare y Medicaid, Medicare nunca lo contactará sin permiso para pedirle su número 
                    de beneficiario o cualquier otra información personal. Tampoco te llamará para venderte nada. Su 
                    número de Medicare es información personal, no la comparta con nadie y nunca pague por una vacuna 
                    contra el COVID-19. Son gratis.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/medicalEs.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Los estafadores usan números de teléfono ficticios que parecen provenir de Washington, DC para parecer creíbles.
                    <br/>
                    “Recibes una llamada telefónica acosadora informándote que tu número de Seguro Social fue usado en un crimen y 
                    que pronto serás arrestado si no envías dinero para resolverlo”. Es posible que digan que su número se usó para 
                    alquilar un automóvil en el que se encontraron drogas y que la Administración para el Control de Drogas está de 
                    camino a su casa. La persona que llama puede indicarle que visite un sitio web local de la policía donde puede 
                    ver su foto. Crees que lo has verificado, vuelves a llamar y envías dinero.
                    <br/>
                    <b>NUNCA</b> responda llamadas de números de teléfono que no conoce. "Si es importante, te dejarán un mensaje".
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/ssnscamEs.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Los estafadores envían mensajes de texto ficticios que afirman que hay un gran problema con su cuenta 
                    de Internet, tarjeta de crédito, cuenta bancaria o pedido de compra de Amazon. Quieren que haga clic en 
                    enlaces y proporcione información personal.
                    <br/>
                    "El mensaje de texto que parece tan urgente puede tener un logotipo que parece legítimo". "La gente no 
                    espera que los estafadores usen mensajes de texto, por lo que es más probable que hagan clic".
                    <br/>
                    <b>NUNCA</b> haga clic en enlaces que llegan en correos electrónicos y mensajes de texto que no ha 
                    solicitado. Llame al banco oa la compañía de la tarjeta de crédito para averiguar si realmente hay 
                    un problema. También es fundamental instalar programas de protección en tu ordenador y mantenerlos 
                    actualizados.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/textScamEs.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Los estafadores registraron más de 2.449 dominios de internet ficticios vinculados a Zoom durante los 
                    primeros meses de la pandemia, que servían para poder enviar mensajes electrónicos que parecían ser 
                    del sitio web de videoconferencias “Zoom”.
                    <br/>
                    “Recibe un correo electrónico, mensaje de texto o de redes sociales con el logotipo de Zoom, 
                    invitándolo a hacer clic en un enlace porque su cuenta está suspendida o se perdió una reunión”. 
                    “Cuando se hace clic, permite a los delincuentes descargar malware en su computadora, acceder a su 
                    información personal para robar su identidad o buscar contraseñas para piratear otras cuentas”.
                    <br/>
                    <b>NUNCA</b> hagas clic en enlaces que te lleguen en correos electrónicos, mensajes de texto o 
                    redes sociales que no hayas solicitado. Visite siempre los sitios web de las empresas 
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/zoom.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Muchas personas que han sido vacunadas contra el COVID-19 han publicado selfies en las redes 
                    sociales para mostrar sus tarjetas de vacunación. Los estafadores se aprovecharon de inmediato.
                    <br/>
                    “Con tu nombre completo, tu fecha de nacimiento y la información de dónde recibiste la vacuna, 
                    los estafadores tienen información valiosa para robar tu identidad, acceder a tus cuentas bancarias, 
                    sacar tarjetas de crédito a tu nombre y mucho más”.
                    <br/>
                    <b>NUNCA</b> exponga su información personal en las redes sociales. “Se recomienda que utilice los 
                    marcos de fotos de perfil que ofrecen las redes sociales” Revise la configuración de seguridad de 
                    las plataformas de redes sociales para elegir quién puede ver sus publicaciones. 
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/vacunEs.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Los sitios web minoristas fraudulentos no son nuevos, pero parecen más reales que nunca. "Los sitios 
                    ficticios usan fotos de los minoristas en línea reales y copian su apariencia".
                    <br/>
                    “Cuando haces clic en un anuncio en línea o en las redes sociales, ves productos que te gustan a un 
                    buen precio, ingresas la información de tu tarjeta de crédito… y nunca recibes el producto. O recibe 
                    un artículo de mala calidad enviado directamente por un vendedor en el extranjero”.
                    <br/>
                    <b>NUNCA</b> haga clic en un anuncio para visitar el sitio web de un minorista. En su lugar, guarde 
                    las URL de los sitios web confiables donde compra con frecuencia y visítelos. Cuando considere comprar 
                    algo de un sitio web con el que no está familiarizado, primero lea las reseñas en línea y el historial 
                    de la empresa.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/apps.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Durante la pandemia, estrellas famosas como Kim Kardashian y Justin Bieber aparecieron en los 
                    titulares con premios en metálico en las redes sociales. Sus fans publicaron su ID de la 
                    aplicación de transferencia de fondos (o $ Cashtag , en Cash App) para tener la oportunidad 
                    de ganar dinero. Los estafadores no tardaron en hacerse pasar por estrellas famosas y comenzaron 
                    a ofrecer premios ficticios para obtener su información privada.
                    <br/>
                    “Recibes una nota en las redes sociales, en un correo electrónico o en un mensaje de texto, 
                    haciéndote saber que gano. Solo necesita verificar la información de su cuenta y enviar un 
                    pequeño depósito por adelantado”.
                    <br/>
                    <b>SI REALMENTE GANASTE ALGO</b>, no te pedirán que envíes dinero primero. Si algo suena 
                    demasiado bueno para ser verdad, probablemente no lo sea.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/shopOnline.png" alt="alert" />
                </div>
              </div>
            </div> 
            
            :
            
            <div className="col-md-12" style={{padding:25}}>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Stalking doesn't just happen on dating sites. “Romance scammers target unsuspecting people in virtual 
                    prayer groups and reading groups, in virtual games like Words With Friends and other groups we turn to 
                    due to the isolation imposed by the pandemic.”
                    <br/>
                    “Scammers often invite their romance victims away from sites that can be monitored and lead them to Google 
                    Hangouts, WhatsApp, Facebook or Messenger where no one is watching, and start asking for money.”
                    <br/>
                    <b>NEVER</b> send money to someone you don't know. Reject requests for provocative selfies and videos 
                    that a scammer can later use to extort money from you.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/dateEn.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Scammers send emails, and phone calls, and even walk into homes posing as Medicare employees 
                    and offering all kinds of pandemic-related services to obtain your Medicare ID number.
                    <br/>
                    “The offers include new cards that, according to the scammers, contain microchips”, Other scammers 
                    ask for money to advance beneficiaries in line to receive the COVID-19 vaccine”.
                    <br/>
                    <b>HANG UP</b> the call, close the door, and delete the email. According to the Centers for 
                    Medicare & Medicaid Services, Medicare will never contact you without permission to ask for 
                    your beneficiary number or any other personal information. Nor will he call you to sell you 
                    anything. Your Medicare number is personal information, don't share it with anyone, and never 
                    pay for a COVID-19 vaccine. They are free.

                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/medicalEn.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Scammers are using fictitious phone numbers that appear to come from Washington, D.C. to appear believable.
                    <br/>
                    “You receive a harassing phone call informing you that your Social Security number was used in a crime 
                    and that you will be arrested soon if you don't send money to solve it.” They may say that your number 
                    was used to rent a car in which drugs were found and that the Drug Enforcement Administration is on its 
                    way to your house. The caller may direct you to visit a local law enforcement website where he can see 
                    his photo. You think you've verified it, and call back and send money.
                    <br/>
                    <b>NEVER</b> answer calls from phone numbers you don't know. "If it's important, they'll leave a message for you."
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/ssnscamEn.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Scammers are sending fictitious text messages claiming there's a big problem with your internet 
                    account, credit card, bank account, or Amazon purchase order. They want you to click on links and 
                    provide personal information.
                    <br/>
                    "The text message that seems so urgent may have a logo that looks legitimate." "People don't expect 
                    scammers to use text messages and so they're more likely to click."
                    <br/>
                    <b>NEVER</b> click on links that arrive in emails and text messages that you have not 
                    requested. Call the bank or credit card company to find out if there really is a problem. 
                    It is also essential to install protection programs on your computer and keep them up to date.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/textScamEn.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Scammers registered more than 2,449 fictitious internet domains linked to Zoom during the first 
                    months of the pandemic, which were used to be able to send electronic messages that appeared 
                    to be from the “Zoom” video conferencing website.
                    <br/>
                    “You receive an email, text or social media message with the Zoom logo, inviting you to click 
                    on a link because your account is suspended or you missed a meeting.” “When clicked, it allows 
                    criminals to download malware onto your computer, access your personal information to steal your 
                    identity, or look up passwords to hack into other accounts.”
                    <br/>
                    <b>NEVER</b> click on links that arrive in emails, text messages or social media that you 
                    have not requested. Always visit the real companies’ websites.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/zoomEn.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Many people who have been vaccinated against COVID-19 have posted selfies on social media to 
                    show off their vaccination cards. The scammers took advantage immediately.
                    <br/>
                    “With your full name, your date of birth, and the information on where you received the vaccine, 
                    scammers have valuable information to steal your identity, access your bank accounts, take out 
                    credit cards in your name, and much more.”
                    <br/>
                    <b>NEVER</b> expose your personal information on social networks. “It is recommended that you 
                    use profile photo frames offered by social media” Review the security settings of social media 
                    platforms to choose who can see your posts.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/vacunEn.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    Fraudulent retail websites aren't new, but they seem more real than ever. "The fictitious sites use 
                    photos of the real online retailers and copy their look and feel."
                    <br/>
                    “When you click on an ad online or on social media, you see products you like at a good price, you 
                    enter your credit card information…and you never receive the product. Or you get a poor quality item 
                    shipped directly from an overseas seller.”
                    <br/>
                    <b>NEVER</b> click on an ad to visit a retailer's website. Instead, save the URLs of trustworthy 
                    websites where you shop frequently and visit those. When considering buying something from a website 
                    you're not familiar with, first read online reviews and the track record of the company.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/appEn.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="col-md-9">
                  <p>
                    During the pandemic, famous stars like Kim Kardashian and Justin Bieber made headlines with 
                    prize money on social media. His fans posted their funds transfer app ID (or $Cashtag, in Cash 
                    App) for a chance to win money. It didn't take long for the scammers to impersonate famous 
                    stars and began offering fictitious prizes in order to obtain your private information.
                    <br/>
                    “You get a note on social media, in an email or a text message, letting you know I win. You 
                    just need to verify your account information and send a small deposit up front.”
                    <br/>
                    <b>IF YOU REALLY EARNED SOMETHING</b>, they won't ask you to send money 
                    first. If something sounds too good to be true, it probably isn't.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" src="img/elderAbuse/shopOnline.png" alt="alert" />
                </div>
              </div>
            </div> 
            
          }
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./js/elderAbuseContent/PopularScams.js